import { combineReducers } from "redux";
import gatewayAndPriceListReducer from "./gateway_and_price_list_reducer";
import gatewayAndPriceListEmailReducer from "./gateway_and_price_list_email_reducer";
import gatewayAndPriceListWhatsappReducer from "./gateway_and_price_list_whatsapp_reducer";
import gatewayAndPriceListWhatsapp2Reducer from "./price_list_whatsapp_2_reducer";
import gatewayAndPriceListRCSReducer from "./price_list_rcs_reducer";

const gatewayAndPriceReducer = combineReducers({
    gatewayAndPriceList: gatewayAndPriceListReducer,
    gatewayAndPriceListEmail: gatewayAndPriceListEmailReducer,
    whatsapp: gatewayAndPriceListWhatsappReducer,
    whatsapp2: gatewayAndPriceListWhatsapp2Reducer,
    rcs: gatewayAndPriceListRCSReducer
});

export default gatewayAndPriceReducer;
